export default __webpack_public_path__ + "static/media/user-pics-5.13f1f514.png";